import Vue from 'vue'

const getters = {
  listAll: state => {
    var filteredMedia = []
    for (let index = 0; index < state.media_list.length; index++) {
      const element = state.media_list[index]
      if (!element.DeviceDesktop) filteredMedia.push(element)
    }
    return filteredMedia
  },
  listImage: state => {
    var filteredMedia = []
    for (let index = 0; index < state.media_list.length; index++) {
      const element = state.media_list[index]
      if (element.type === 'Image') filteredMedia.push(element)
    }
    return filteredMedia
  },
  listVideo: state => {
    var filteredMedia = []
    for (let index = 0; index < state.media_list.length; index++) {
      const element = state.media_list[index]
      if (element.type === 'Video') filteredMedia.push(element)
    }
    return filteredMedia
  },
  listPlayList: state => {
    var filteredMedia = []
    for (let index = 0; index < state.media_list.length; index++) {
      const element = state.media_list[index]
      if (element.type === 'PlayList' && !element.DeviceDesktop) filteredMedia.push(element)
    }
    return filteredMedia
  }
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/medium/medium.getters.js
// module id = null
// module chunks = 